import { useTranslation } from "react-i18next";

const SaleReportHeader = ({ onExport, isExporting }) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-[#111729]">
            {t(
              "extendedWarranty.reports.header.title",
              "Ek Garanti Raporlama",
            )}
          </h1>
          <p className="mt-1 text-sm text-[#677389]">
            {t(
              "extendedWarranty.reports.header.description",
              "Mağaza satış noktalarındaki ek garanti performans analizi",
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SaleReportHeader;
